import React, { useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import config from "../../../config";

const ReviewModal = ({ isOpen, handleClose, vendorId, onSuccess }) => {
    const [action, setAction] = useState("");
    const [remarks, setRemarks] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!action) {
            toast.error("Please select an action");
            return;
        }
        if (action === "EDIT_REQUESTED" && !remarks) {
            toast.error("Please provide remarks for changes");
            return;
        }

        setLoading(true);
        const token = sessionStorage.getItem("tokenKey");

        // Construct payload based on action
        // Construct payload based on action
        let payload = {
            action: action,
            remarks: remarks || "" // Remarks optional for approve but key likely required or safe to send
        };

        // The user specified: http://127.0.0.1:8000/api/v2/event-vendors/admin/1/action/
        // We assume config.service points to .../api, so we access v2 here
        // Verify if config.service includes 'api' at the end.
        // Based on previous file view: service: "https://apiprod.bookwedgo.com/api"
        // So we need to strip 'api' if we want to replace it or just append /v2/ if the base is just host
        // Actually typically config.service is just the base API URL.
        // Let's assume we append /v2/event-vendors/admin/${vendorId}/action/ to it if the backend handles it.
        // Wait, the user said: http://127.0.0.1:8000/api/v2/event-vendors/admin/1/action/
        // If config.service is ".../api", then we might need to be careful. 
        // Let's try to infer from typical usage: config.service + "/v2/..."

        // However, usually projects reference v1 by default. Let's try to use the path provided.

        const url = `${config.service}/v2/event-vendors/admin/${vendorId}/action/`;

        try {
            await axios.post(url, payload, {
                headers: { Authorization: `Token ${token}` },
            });
            toast.success("Action submitted successfully");
            onSuccess();
            handleClose();
        } catch (err) {
            console.error(err);
            toast.error(
                err.response?.data?.message || "Failed to submit action"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Process Vendor Application</DialogTitle>
            <DialogContent>
                <div style={{ marginTop: "10px", display: "flex", flexDirection: "column", gap: "15px" }}>
                    <FormControl fullWidth>
                        <InputLabel>Action</InputLabel>
                        <Select
                            value={action}
                            label="Action"
                            onChange={(e) => setAction(e.target.value)}
                        >
                            <MenuItem value="APPROVE">Approve</MenuItem>
                            <MenuItem value="EDIT_REQUESTED">Request Changes</MenuItem>
                            <MenuItem value="REJECT">Reject</MenuItem>
                        </Select>
                    </FormControl>

                    {action === "EDIT_REQUESTED" && (
                        <TextField
                            label="Remarks / Changes Required"
                            multiline
                            rows={4}
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            fullWidth
                            placeholder="Please upload clearer portfolio images..."
                        />
                    )}
                    {action === "REJECT" && (
                        <TextField
                            label="Reason for Rejection"
                            multiline
                            rows={4}
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            fullWidth
                        />
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                >
                    {loading ? "Processing..." : "Submit"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReviewModal;
